<template>
  <div>
    <div class="head">
      <el-breadcrumb style="margin-left:20px"
        separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>全流程安全生产</el-breadcrumb-item>
        <el-breadcrumb-item>考核评审管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div>
      <div class="content1">
        <div>
          <span>隐患排查/隐患整改</span>
        </div>
        <div id="content1" class="content1" />
      </div>
      <div class="content1" style="margin-left: 1%">
        <div>
          <span>使用次数统计</span>
        </div>
        <div id="content6" class="content1" />
      </div>
      <div class="content1" style="margin-left: 1%">
        <div>
          <span>培训计划/安全巡检</span>
        </div>
        <div id="content2" class="content1" />
      </div>
    </div>

    <div>
      <div class="content2" style="margin-top: 1%">
        <div>
          <span>作业</span>
        </div>
        <div id="content3" class="content2" />
      </div>
      <div class="content2" style="margin-left: 1%;margin-top: 1%">
        <div>
          <span>事故</span>
        </div>
        <div id="content4" class="content2" />
      </div>
      <div class="content2" style="margin-left: 1%;margin-top: 1%">
        <div>
          <span>演练</span>
        </div>
        <div id="content5" class="content2" />
      </div>
    </div>

    <div>
      <div class="content2" style="margin-top: 1%">
        <div>
          <span>使用次数统计</span>
        </div>
        <div id="content7" class="content2" />
      </div>
    </div>
  </div>
</template>

<script>
import { getList, postInfo } from '../process/api/http'

export default {
  data() {
    return {
      total: 10,
      sizePage: 10,
      currentPage: 1,
      tableData: []
    }
  },
  created() {},
  mounted: function() {
    this.getData()
  },
  methods: {
    drawLine1(data) {
      let myChart1 = this.$echarts.init(document.getElementById('content1'))
      let option = {
        legend: {},
        tooltip: {},
        dataset: {
          // 用 dimensions 指定了维度的顺序。直角坐标系中，
          // 默认把第一个维度映射到 X 轴上，第二个维度映射到 Y 轴上。
          // 如果不指定 dimensions，也可以通过指定 series.encode
          // 完成映射，参见后文。
          dimensions: ['product', '隐患排查', '隐患整改'],
          source: data
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: 0,
            rotate: 40
          }
        },
        yAxis: {},
        series: [
          { type: 'bar', itemStyle: { color: 'rgba(172, 172, 255, 0.8)' } },
          { type: 'bar', itemStyle: { color: 'rgba(74, 74, 255, 0.8)' } }
        ]
      }
      myChart1.setOption(option)
    },
    drawLine6(data) {
      let myChart6 = this.$echarts.init(document.getElementById('content6'))
      let option = {
        legend: {},
        tooltip: {},
        dataset: {
          dimensions: ['product', '基础数据', '风险辨识', '安全制度'],
          source: data
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: 0,
            rotate: 40
          }
        },
        yAxis: {},
        series: [
          { type: 'bar', itemStyle: { color: 'rgba(172, 172, 255, 0.8)' } },
          { type: 'bar', itemStyle: { color: 'rgba(74, 74, 255, 0.8)' } },
          { type: 'bar', itemStyle: { color: 'rgba(130, 22, 237, 0.8)' } },
        ]
      }
      myChart6.setOption(option)
    },
    drawLine2(data) {
      let myChart2 = this.$echarts.init(document.getElementById('content2'))
      let option = {
        legend: {},
        tooltip: {},
        dataset: {
          source: data,
          // 用 dimensions 指定了维度的顺序。直角坐标系中，
          // 默认把第一个维度映射到 X 轴上，第二个维度映射到 Y 轴上。
          // 如果不指定 dimensions，也可以通过指定 series.encode
          // 完成映射，参见后文。
          dimensions: ['product', '安全巡检', '培训计划']
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: 0,
            rotate: 40
          }
        },
        yAxis: {},
        series: [
          { type: 'bar', itemStyle: { color: 'rgba(0, 236, 118, 0.8)' } },
          { type: 'bar', itemStyle: { color: 'rgba(140, 255, 198, 0.8)' } }
        ]
      }
      myChart2.setOption(option)
    },
    drawLine3(x, y) {
      let myChart3 = this.$echarts.init(document.getElementById('content3'))
      let option = {
        title: {
          text: '安全作业统计',
          textStyle: {
            fontSize: 12
          },
          left: '43%'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: x,
          axisLabel: {
            interval: 0,
            rotate: 40
          }
        },
        yAxis: {
          type: 'value'
        },
        axisLabel: {
          interval: 0,
          rotate: 40
        },
        series: [
          {
            data: y,
            type: 'bar',
            showBackground: false,
            backgroundStyle: {
              color: 'rgba(255, 128, 0, 0.8)'
            }
          }
        ],
        itemStyle: { color: 'rgba(255, 128, 0, 0.8)' }
      }
      myChart3.setOption(option)
    },
    drawLine4(x, y) {
      let myChart4 = this.$echarts.init(document.getElementById('content4'))
      let option = {
        title: {
          text: '事故统计',
          textStyle: {
            fontSize: 12
          },
          left: '43%'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: x,
          axisLabel: {
            interval: 0,
            rotate: 40
          }
        },
        yAxis: {
          type: 'value'
        },
        axisLabel: {
          interval: 0,
          rotate: 40
        },
        series: [
          {
            data: y,
            type: 'bar',
            showBackground: false,
            backgroundStyle: {
              color: 'rgba(220, 220, 220, 0.8)'
            }
          }
        ],
        itemStyle: { color: 'rgba(255, 119, 119, 0.8)' }
      }
      myChart4.setOption(option)
    },
    drawLine5(x, y) {
      let myChart5 = this.$echarts.init(document.getElementById('content5'))
      let option = {
        title: {
          text: '演练统计',
          textStyle: {
            fontSize: 12
          },
          left: '43%'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: x,
          axisLabel: {
            interval: 0,
            rotate: 40
          }
        },
        yAxis: {
          type: 'value'
        },
        axisLabel: {
          interval: 0,
          rotate: 40
        },
        series: [
          {
            data: y,
            type: 'bar',
            showBackground: false,
            backgroundStyle: {
              color: 'rgba(220, 220, 220, 0.8)'
            }
          }
        ],
        itemStyle: { color: 'rgba(0, 236, 118, 0.8)' }
      }

      myChart5.setOption(option)
    },

    drawLine7(data) {
      let myChart7 = this.$echarts.init(document.getElementById('content7'))
      let option = {
        legend: {},
        tooltip: {},
        dataset: {
          source: data,
          // 用 dimensions 指定了维度的顺序。直角坐标系中，
          // 默认把第一个维度映射到 X 轴上，第二个维度映射到 Y 轴上。
          // 如果不指定 dimensions，也可以通过指定 series.encode
          // 完成映射，参见后文。
          dimensions: ['product', '考试', '学习']
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: 0,
            rotate: 40
          }
        },
        yAxis: {},
        series: [
          { type: 'bar', itemStyle: { color: 'rgba(0, 236, 118, 0.8)' } },
          { type: 'bar', itemStyle: { color: 'rgba(140, 255, 198, 0.8)' } }
        ]
      }
      myChart7.setOption(option)
    },
    getData() {
      let param = {}
      param.limit = this.pageSize
      param.curPage = this.currentPage
      this.componentsMoudel.httpRequest
        .getRequestHander('/statistics/statisticsAll')
        .openLoad()
        .startGet(param)
        .then(res => {
          this.tableData = res.body.data
          let hidden = []
          for (var i = 0; i < 6; i++) {
            let data = {
              product: this.tableData.hidden.yearMonth[i],
              隐患排查: this.tableData.troubleshoot.totalCount[i],
              隐患整改: this.tableData.hidden.totalCount[i]
            }
            hidden.push(data)
          }
          this.drawLine1(hidden.reverse())
          let use = []
          for (let i = 0; i < 6; i++) {
            let data = {
              product: this.tableData.baseData.yearMonth[i],
              基础数据: this.tableData.baseData.totalCount[i],
              风险辨识: this.tableData.riskIdentification.totalCount[i],
              安全制度: this.tableData.safetyRegulation.totalCount[i],
            }
            use.push(data)
          }
          this.drawLine6(use.reverse())
          let safe = []
          for (var i = 0; i < 6; i++) {
            let data = {
              product: this.tableData.cultivate.yearMonth[i],
              培训计划: this.tableData.cultivate.totalCount[i],
              安全巡检: this.tableData.inspectionRecord.totalCount[i]
            }
            safe.push(data)
          }
          this.drawLine2(safe.reverse())
          let workPermit = this.tableData.workPermit
          let accidentBulletin = this.tableData.accidentBulletin
          let drillingPlan = this.tableData.drillingPlan
          this.drawLine3(
            workPermit.yearMonth.slice(0, 6).reverse(),
            workPermit.totalCount.slice(0, 6).reverse()
          )
          this.drawLine4(
            accidentBulletin.yearMonth
              .slice(0, 6)
              .slice(0, 6)
              .reverse(),
            accidentBulletin.totalCount.slice(0, 6).reverse()
          )
          this.drawLine5(
            drillingPlan.yearMonth.slice(0, 6).reverse(),
            drillingPlan.totalCount.slice(0, 6).reverse()
          )

          let examin = []
          for (let k = 0; k < 6; k++) {
            let data = {
              product: this.tableData.exam.yearMonth[k],
              考试: this.tableData.exam.totalCount[k],
              学习: this.tableData.learn.totalCount[k]
            }
            examin.push(data)
          }
          this.drawLine7(examin)
        })
    }
  }
}
</script>

<style scoped>
.content1 {
  background-color: #ffffff;
  width: 32%;
  display: flex;
  height: 40vh;
  flex-direction: column;
  padding: 10px;
  border: 1px solid #e9eef3;
  float: left;
}

.content2 {
  background-color: #ffffff;
  width: 32%;
  display: flex;
  height: 40vh;
  flex-direction: column;
  padding: 10px;
  border: 1px solid #e9eef3;
  float: left;
}

#content1 {
  height: 38vh;
  width: 100%;
}
#content2 {
  height: 38vh;
  width: 100%;
}
#content3 {
  height: 38vh;
  width: 100%;
}
#content4 {
  height: 38vh;
  width: 100%;
}
#content5 {
  height: 38vh;
  width: 100%;
}
#content6 {
  height: 38vh;
  width: 100%;
}
#content7 {
  height: 38vh;
  width: 100%;
}
</style>
